const FALLBACK_MONTHS = [
    "janvier", "février", "mars", "avril", "mai", "juin",
    "juillet", "août", "septembre", "octobre", "novembre", "décembre",
];

const KEY_PREFIX = "endOfMissionDocuments";

// French elides "de" before a vowel: "fiche de paie d’octobre", "d’avril", "d’août".
const STARTS_WITH_VOWEL = /^[aeiouyàâäéèêëîïôöûü]/i;

export const translateEndOfMission = (language, key, fallback, values = {}) =>
    Object.entries(values).reduce(
        (text, [name, value]) => text.replace(`{${name}}`, value),
        language.getValue(`${KEY_PREFIX}.${key}`, fallback)
    );

// payMonth is "YYYY-MM"; offset shifts the month (1 = following month).
export const parsePayMonth = (payMonth, offset = 0) => {
    const [yearText, monthText] = String(payMonth || "").split("-");
    const year = Number(yearText);
    const month = Number(monthText);
    if (!Number.isInteger(year) || !Number.isInteger(month) || month < 1 || month > 12) return null;
    const monthIndex = month - 1 + offset;
    return {
        year: year + Math.floor(monthIndex / 12),
        monthIndex: ((monthIndex % 12) + 12) % 12,
    };
};

export const getMonthName = (language, monthIndex) => {
    const months = language.getValue(`${KEY_PREFIX}.months`, FALLBACK_MONTHS);
    return (Array.isArray(months) ? months : FALLBACK_MONTHS)[monthIndex] || "";
};

export const formatMonthTitle = (language, payMonth) => {
    const parsed = parsePayMonth(payMonth);
    if (!parsed) return payMonth || "";
    const name = getMonthName(language, parsed.monthIndex);
    return `${name.charAt(0).toUpperCase()}${name.slice(1)} ${parsed.year}`;
};

// Picks the elided variant of a text when the month name starts with a vowel.
export const translateWithMonth = (language, key, fallback, elidedFallback, monthName) =>
    STARTS_WITH_VOWEL.test(monthName)
        ? translateEndOfMission(language, `${key}_elided`, elidedFallback, { month: monthName })
        : translateEndOfMission(language, key, fallback, { month: monthName });

export const formatReceivedDate = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    return Number.isNaN(date.getTime()) ? "" : date.toLocaleDateString("fr-FR");
};

// Groups documents by payMonth, most recent month first, keeping the api order inside a month.
export const groupDocumentsByMonth = (documents) => {
    const groups = new Map();
    documents.forEach((document) => {
        const key = document.payMonth || "";
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(document);
    });
    return [...groups.entries()]
        .sort(([monthA], [monthB]) => monthB.localeCompare(monthA))
        .map(([payMonth, items]) => ({ payMonth, documents: items }));
};
